export default __webpack_public_path__ + "static/media/Desdobravel1.f81d6b69.jpg";